import { useQuery } from '@apollo/client'
import { InvitationGetQuery, InvitationGetQueryVariables } from 'src/generated'

import QUERY from './query.gql'

/**
 * What an invitation link says. Anonymous: the person opening it may have no
 * account yet, and a session they do have is not the one the link is for.
 */
export const useInvitationGetQuery = (token: string | null) =>
  useQuery<InvitationGetQuery, InvitationGetQueryVariables>(QUERY, {
    variables: { input: { token: token ?? '' } },
    skip: !token,
    // Read once per visit and never shared: whether a link still works is the
    // answer, and a cached `pending` would offer a sign-in it can no longer give.
    fetchPolicy: 'no-cache',
    context: { anonymous: true },
  })
